/**
 * Synthetic LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SecondLegSettingCreateUpdateRequest {
  /**
   * Second leg base pair ID.
   */
  secondLegBasePairId: number;
  /**
   * Min execution qty for second leg by pair ID.
   */
  minTradeQty: number;
  /**
   * Can be positive, negative and Zero.
   */
  positionGoal: number;
  /**
   * Has to be LP pair ID.
   */
  firstExtraPairId?: number;
  /**
   * In 0.1 bps. First pair max allowable spread. Required if firstExtraPairId is filled.
   */
  firstExtraPairMaxSpread?: number;
  /**
   * Has to be LP pair ID.
   */
  secondExtraPairId?: number;
  /**
   * In 0.1 bps. Second pair max allowable spread. Required if secondExtraPairId is filled.
   */
  secondExtraPairMaxSpread?: number;
  /**
   * In 0.1 bps. Increase in spread in case of MD substitution on the second leg. Required if at least one of extra pairs is filled.
   */
  widenSpread?: number;
  /**
   * If True - Streaming synthetic V2 MD and prohibition of second leg market order sending.
   */
  noMdFromLpMode: boolean;
}
